import { imageContext } from "./ImageContext";
interface Props {
	imageUrlBase: string;
	children: React.ReactNode;
}

export const ImageProvider: React.FC<Props> = ({ children, imageUrlBase }) => {
	return (
		<imageContext.Provider value={{ imageUrlBase }}>
			{children}
		</imageContext.Provider>
	);
};
